import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './config/store';
import { PersistGate } from 'redux-persist/integration/react'
import AppRouter from './routes';
import { TOGGLE_LOADER } from './actions/types';

const root = ReactDOM.createRoot(document.getElementById('root'));
store.dispatch({
  type: TOGGLE_LOADER,
  payload: false
});

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppRouter />
    </PersistGate>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
